import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home').then((m) => m.Home),
  },
  // Blog
  {
    path: 'blog',
    loadComponent: () => import('./blog/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'blog/:slug',
    loadComponent: () => import('./blog/details/details.component').then((m) => m.DetailsComponent),
  },
  // Branch Offices
  {
    path: 'sucursales',
    loadComponent: () => import('./branch-office/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'sucursales/:slug',
    loadComponent: () =>
      import('./branch-office/detail/detail.component').then((m) => m.DetailComponent),
  },
  // Brands
  {
    path: 'marcas',
    loadComponent: () => import('./brands/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'marcas/:brand',
    loadComponent: () => import('./brands/detail/detail.component').then((m) => m.DetailComponent),
  },
  {
    path: 'marcas/:brand/productos',
    loadComponent: () =>
      import('./brands/families/families.component').then((m) => m.FamiliesComponent),
  },
  // Contact
  {
    path: 'contacto',
    loadComponent: () => import('./contact/contact.component').then((m) => m.ContactComponent),
  },
  // Services
  {
    path: 'servicio',
    loadComponent: () =>
      import('./customer-service/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'servicio/:slug',
    loadComponent: () =>
      import('./customer-service/detail/detail.component').then((m) => m.DetailComponent),
  },
  // Digital Solutions
  {
    path: 'soluciones-digitales',
    loadComponent: () =>
      import('./digital-solutions/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'soluciones-digitales/:solution',
    loadComponent: () =>
      import('./digital-solutions/detail/detail.component').then((m) => m.DetailComponent),
  },
  // Enterprise
  {
    path: 'empresa',
    loadComponent: () =>
      import('./enterprise/about-us/about-us.component').then((m) => m.AboutUsComponent),
  },
  {
    path: 'empresa/responsabilidad-social',
    loadComponent: () =>
      import('./enterprise/social-responsability/social-responsability.component').then(
        (m) => m.SocialResponsabilityComponent,
      ),
  },
  {
    path: 'empresa/facturacion',
    loadComponent: () =>
      import('./enterprise/invoicing/invoicing.component').then((m) => m.InvoicingComponent),
  },
  {
    path: 'empresa/bolsa-de-trabajo',
    loadComponent: () =>
      import('./enterprise/careers/careers.component').then((m) => m.CareersComponent),
  },
  {
    path: 'empresa/historia',
    loadComponent: () =>
      import('./enterprise/history/history.component').then((m) => m.HistoryComponent),
  },
  // Thanks
  {
    path: 'equipo-en-renta/gracias',
    loadComponent: () => import('./thanks/rent/rent.component').then((m) => m.RentComponent),
  },
  {
    path: 'gracias/:slug',
    loadComponent: () =>
      import('./thanks/general/general.component').then((m) => m.GeneralComponent),
  },
  // Politics
  {
    path: 'proceso-de-renta',
    loadComponent: () =>
      import('./politics/income-policy/income-policy.component').then(
        (m) => m.IncomePolicyComponent,
      ),
  },
  // Promotions
  {
    path: 'promociones',
    loadComponent: () => import('./promotions/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'promociones/:category',
    loadComponent: () => import('./promotions/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'promociones/:category/:slug',
    loadComponent: () =>
      import('./promotions/detail/detail.component').then((m) => m.DetailComponent),
  },
  // Landings
  {
    path: 'financiamiento',
    loadComponent: () =>
      import('./landings/financing/financing.component').then((m) => m.FinancingComponent),
  },
  /* {
    path: 'cat-card',
    loadComponent: () =>
      import('./landings/cat-card/cat-card.component').then((m) => m.CatCardComponent),
  },
  {
    path: 'cuenta-comercial-cat',
    loadComponent: () =>
      import('./landings/comercial-account/comercial-account.component').then((m) => m.ComercialAccountComponent),
  },*/
  // Providers
  {
    path: 'empresa/proveedores',
    loadComponent: () =>
      import('./providers/providers.component').then((m) => m.ProvidersComponent),
  },
  // Rent
  {
    path: 'equipo-en-renta',
    loadComponent: () => import('./rent/home/home.component').then((m) => m.HomeComponent),
  },
  // Spare parts
  {
    path: 'refacciones',
    loadComponent: () => import('./spare-parts/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'refacciones/:slug',
    loadComponent: () =>
      import('./spare-parts/family/family.component').then((m) => m.FamilyComponent),
  },
  {
    path: 'refacciones/:slug/:detail',
    loadComponent: () =>
      import('./spare-parts/detail/detail.component').then((m) => m.DetailComponent),
  },
  // Used equipment
  {
    path: 'equipo-usado',
    loadComponent: () =>
      import('./used-equipments/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'equipo-usado/categorias',
    loadComponent: () =>
      import('./used-equipments/category/category.component').then((m) => m.CategoryComponent),
  },
  {
    path: 'equipo-usado/categorias/:category',
    loadComponent: () =>
      import('./used-equipments/subcategory/subcategory.component').then(
        (m) => m.SubcategoryComponent,
      ),
  },
  {
    path: 'equipo-usado/categorias/:category/:subCategory',
    loadComponent: () =>
      import('./used-equipments/equipments-list/equipments-list.component').then(
        (m) => m.EquipmentsListComponent,
      ),
  },
  {
    path: 'equipo-usado/categorias/:category/:subCategory/:unitNumber',
    loadComponent: () =>
      import('./used-equipments/detail/detail.component').then((m) => m.DetailComponent),
  },
  {
    path: 'comparador-equipo-usado',
    loadComponent: () =>
      import('./used-equipments/comparator/comparator.component').then((m) => m.ComparatorComponent),
  },
  // New Equipment
  {
    path: 'productos',
    loadComponent: () => import('./new-equipment/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'productos/:categorySlug',
    loadComponent: () =>
      import('./new-equipment/category/category.component').then((m) => m.CategoryComponent),
  },
  {
    path: 'productos/:categorySlug/:subcategorySlug',
    loadComponent: () =>
      import('./new-equipment/subcategory/subcategory.component').then(
        (m) => m.SubcategoryComponent,
      ),
  },
  {
    path: 'productos/:categorySlug/:subcategorySlug/:brandSlug',
    loadComponent: () =>
      import('./new-equipment/subcategory-brand/subcategory-brand.component').then(
        (m) => m.SubcategoryBrandComponent,
      ),
  },
  {
    path: 'productos/:categorySlug/:subcategorySlug/:brandSlug/:equipmentSlug',
    loadComponent: () =>
      import('./new-equipment/detail/detail.component').then((m) => m.DetailComponent),
  },
  // Parts cat com
  {
    path: 'parts-cat-com',
    loadComponent: () => import('./parts-cat/parts-cat.component').then((m) => m.PartsCatComponent),
  },
  // 404
  {
    path: '404',
    loadComponent: () => import('./not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  // Industries
  {
    path: 'industrias',
    loadComponent: () => import('./industries/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'industrias/:slug',
    loadComponent: () => import('./industries/detail/detail.component').then((m) => m.DetailComponent),
  },
  // Universal
  {
    path: 'legales/:slugLanding',
    loadComponent: () => import('./landings/home/home.component').then((m) => m.HomeComponent),
  },
  //Special
  {
    path: ':slugLanding',
    loadComponent: () => import('./special-landing/special-landing.component').then((m) => m.SpecialLandingComponent),
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
